<template>
  <div class="project mt30">
    <el-row class="contable">
      <el-col :span="24">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span><i class="fa fa-gift fs14" /> Subproject Information</span>
          </div>
          <div>
            <el-form ref="form" :label-position="labelPosition" :model="form" label-width="200px">
              <el-form-item label="Subproject ID">
                <el-input v-model="subprojectid" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Project ID">
                <label for="" class="lableline tablelink" @click="handleProurl(form.project_id)">{{form.project_id}}</label>
              </el-form-item>
              <el-form-item label="ProteomeXchange ID" v-if="isshowall">
                <el-input v-model="form.proteomexchange_id" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Subproject Title">
                <el-input v-model="form.subproject_title" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Subproject Status">
                <el-input v-model="form.subproject_status" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Subproject Tag" v-if="isshowall">
                <el-input v-model="form.subproject_tag" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Species">
                <!-- <a class="lableline" :href="speciesUrl+item.object_idstr" target="_blank" v-for="(item, index) in form.speciesArr" :key="index">
                  {{ item.object_value }}
                  <span v-if="form.speciesCount-1 != index">, </span>
                </a> -->
                <!-- <a class="lableline pointer" @click="handleOpenStat(item.object_value)" target="_blank" v-for="(item, index) in form.speciesArr" :key="index">
                  {{ item.object_value }}
                  <span v-if="form.speciesCount-1 != index">, </span>
                </a>
                <el-tag type="success">CV</el-tag> -->
                <div v-for="(item, index) in form.speciesArr" :key="index" style="display: inline;">
                  <a class="lableline pointer" @click="handleOpenStat(item.object_value)" target="_blank">
                    {{ item.object_value }}
                  </a>
                  <el-tag class="pointer" type="success" @click="handleOpenCv(item.object_idstr)">CV</el-tag>
                  <span v-if="form.speciesCount-1 != index"><el-divider direction="vertical"></el-divider></span>
                </div>
              </el-form-item>
              <el-form-item label="Tissue" v-if="form.tissue || isshowall">
                <el-input v-model="form.tissue" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Cell Type" v-if="form.cell_type || isshowall">
                <el-input v-model="form.cell_type" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Disease" v-if="form.disease || isshowall">
                <el-input v-model="form.disease" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Quantitation" v-if="form.quantitation || isshowall">
                <el-input v-model="form.quantitation" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Digestion" v-if="form.digest || isshowall">
                <el-input v-model="form.digest" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="PTMs" v-if="form.ptm || isshowall">
                <el-input v-model="form.ptm" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Other Information" v-if="isshowall">
                <el-input v-model="form.otherinfo" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Experiment Type">
                <el-input v-model="form.exp_types" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Subproject Summary">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}" v-model="form.subsummary" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Access Level">
                <el-input v-model="form.access_level" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Public Start Date" v-if="isshowall">
                <el-input v-model="form.public_start_date" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Groups" v-if="isshowall">
                <el-input v-model="form.group_name" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Super Project" v-if="isshowall">
                <el-input v-model="form.sproject_name" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="MS Instrument">
                <div v-for="(item, index) in msData" :key="index" class="mt10">
                  <el-input v-model="item.ms_title" :disabled="true"></el-input>
                  <el-table
                    empty-text="No Data"
                    class="mt10"
                    border
                    :data="item.ms_detail"
                    style="width: 100%"
                    v-if="isshowall">
                    <el-table-column
                      prop="ms_object_type"
                      label="Type"
                      width="180">
                    </el-table-column>
                    <el-table-column
                      prop="ms_cv"
                      label="CV"
                      width="180">
                    </el-table-column>
                    <el-table-column
                      prop="ms_accession"
                      label="Accession">
                    </el-table-column>
                    <el-table-column
                      prop="ms_name"
                      label="Name">
                    </el-table-column>
                    <el-table-column
                      prop="ms_value"
                      label="Value">
                    </el-table-column>
                    <el-table-column
                      prop="fragmentation_method"
                      label="Fragmentation method">
                    </el-table-column>
                  </el-table>
                </div>
              </el-form-item>
              <el-form-item label="Experiment Protocol">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}" v-model="form.experimentprotocol" :disabled="true"></el-input>
                <el-table
                  empty-text="No Data"
                  v-if="isshowall"
                  class="mt10"
                  border
                  :data="form.expData"
                  style="width: 100%">
                  <el-table-column
                    prop="ep_object_type"
                    label="Type"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="ep_cv"
                    label="CV"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="ep_accession"
                    label="Accession">
                  </el-table-column>
                  <el-table-column
                    prop="ep_name"
                    label="Name">
                  </el-table-column>
                  <el-table-column
                    prop="ep_value"
                    label="Value">
                  </el-table-column>
                </el-table>
              </el-form-item>
              <el-form-item label="Informatics Protocol">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}" v-model="form.experimentprotocol" :disabled="true"></el-input>
                <el-row :gutter="20" v-if="isshowall" class="formrow">
                  <el-col :span="12">
                    <span>DB search software name</span>
                    <el-input v-model="form.softwarename" :disabled="true"></el-input>
                  </el-col>
                  <el-col :span="12">
                    <span>DB search software version</span>
                    <el-input v-model="form.softwareversion" :disabled="true"></el-input>
                  </el-col>
                </el-row>
                <el-row :gutter="20" v-if="isshowall" class="formrow">
                  <el-col :span="12">
                    <span>Searched database Type</span>
                    <el-input v-model="form.sdtype" :disabled="true"></el-input>
                  </el-col>
                  <el-col :span="12">
                    <span>Searched database Version</span>
                    <el-input v-model="form.sdversion" :disabled="true"></el-input>
                  </el-col>
                </el-row>
                <el-row :gutter="20" v-if="isshowall" class="formrow">
                  <el-col :span="12">
                    <span>Decoy database Type</span>
                    <el-input v-model="form.ddtype" :disabled="true"></el-input>
                  </el-col>
                </el-row>
                <el-row :gutter="20" v-if="isshowall" class="formrow">
                  <el-col :span="12">
                    <span>Quality estimation method</span>
                    <el-input v-model="form.qemethod" :disabled="true"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="quantification method" v-if="isshowall">
                <el-input v-model="form.qemethodvalue" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Database Search Param" v-if="isshowall">
                <label for="" class="lableline">Experiment Designs</label>
                <el-table
                  empty-text="No Data"
                  border
                  :data="expdesData"
                  style="width: 100%">
                  <el-table-column
                    prop="sampleval"
                    label="Sample Number">
                  </el-table-column>
                  <el-table-column
                    prop="replicateval"
                    label="Replicate Numbber">
                  </el-table-column>
                  <el-table-column
                    prop="fractionval"
                    label="Fraction Number">
                  </el-table-column>
                  <el-table-column
                    prop="samplecontrolval"
                    label="Sample-control design">
                  </el-table-column>
                </el-table>
                <el-row :gutter="20" class="formrow">
                  <el-col :span="12">
                    <span>Database search engine name and version</span>
                    <el-input v-model="form.searchEnginenameval" :disabled="true"></el-input>
                  </el-col>
                  <el-col :span="12">
                    <span>Sequence Database name and version</span>
                    <el-input v-model="form.sequencedatabasenameandversionval" :disabled="true"></el-input>
                  </el-col>
                </el-row>
                <el-row :gutter="20" class="formrow">
                  <el-col :span="12">
                    <span>Decoy Database</span>
                    <el-input v-model="form.decoydatabaseval" :disabled="true"></el-input>
                  </el-col>
                  <el-col :span="12">
                    <span>Max Missed cleavage</span>
                    <el-input v-model="form.maxmissedcleavageval" :disabled="true"></el-input>
                  </el-col>
                </el-row>
                <el-row :gutter="20" class="formrow">
                  <el-col :span="12">
                    <span>MS1 tolerance</span>
                    <el-input v-model="form.ms1tol" :disabled="true"></el-input>
                  </el-col>
                  <el-col :span="12">
                    <span>MS2 tolerance</span>
                    <el-input v-model="form.ms2tol" :disabled="true"></el-input>
                  </el-col>
                </el-row>
                <el-row :gutter="20" class="formrow">
                  <el-col :span="12">
                    <span>Fixed Modification</span>
                    <el-input v-model="form.fixedmodival" :disabled="true"></el-input>
                  </el-col>
                  <el-col :span="12">
                    <span>Variable Modification</span>
                    <el-input v-model="form.variablemodival" :disabled="true"></el-input>
                  </el-col>
                </el-row>
                <el-row :gutter="20" class="formrow">
                  <el-col :span="12">
                    <span>Peptide Length</span>
                    <el-input v-model="form.peptidelengthval" :disabled="true"></el-input>
                  </el-col>
                  <el-col :span="12">
                    <span>Peptide Charge</span>
                    <el-input v-model="form.peptidechargeval" :disabled="true"></el-input>
                  </el-col>
                </el-row>
                <label for="" class="lableline">FDR</label>
                <el-table
                  empty-text="No Data"
                  border
                  :data="fdrData1"
                  style="width: 100%">
                  <el-table-column
                    prop="spectrumval"
                    label="Spectrum FDR">
                  </el-table-column>
                  <el-table-column
                    prop="peptideval"
                    label="Peptide FDR">
                  </el-table-column>
                  <el-table-column
                    prop="proteinval"
                    label="Protein FDR">
                  </el-table-column>
                </el-table>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <label for="" class="lableline">Other Information</label>
                    <el-input v-model="form.otherinfoval" :disabled="true"></el-input>
                  </el-col>
                </el-row>
                <el-table
                  empty-text="No Data"
                  class="mt10"
                  border
                  :data="fdrData"
                  style="width: 100%">
                  <el-table-column
                    prop="ip_obejct_type"
                    label="Type"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="ip_cv"
                    label="CV"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="ip_accession"
                    label="Accession">
                  </el-table-column>
                  <el-table-column
                    prop="ip_name"
                    label="Name">
                  </el-table-column>
                  <el-table-column
                    prop="ip_value"
                    label="Value">
                  </el-table-column>
                </el-table>
              </el-form-item>
              <el-form-item label="File Size">
                <el-input v-model="form.file_show" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-checkbox v-model="ischecked" @change="handleShowAll">Show All Information</el-checkbox>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
        <el-card class="box-card mt20" shadow="never">
          <div slot="header" class="clearfix">
            <span><i class="fa fa-cogs fs14" /> Data File</span>
            <div style="float: right; ">
              <el-button style="padding: 5px 10px" type="warning" round>
                <i class="fa fa-cloud-download" /> Download all files by aspera
              </el-button>
              <el-button style="padding: 5px 10px" type="warning" icon="el-icon-download" @click.stop="handleBatchDownload" round>Http</el-button>
              <el-button style="padding: 5px 10px" type="warning" round>
                <i class="fa fa-cloud-download" /> Aspera
              </el-button>
            </div>
          </div>
          <div>
            Search: <el-input size="medium" v-model="searchkey" placeholder="" class="searchInput mr5" clearable></el-input>
            <el-button class="submitbtn" @click="handleSearch">Search</el-button>
            <el-table
              class="mt10"
              v-loading="loading"
              :row-key="getRowKey"
              empty-text="No Data"
              :data="dfileData"
              @sort-change="handleSort"
              @select="handleSelect"
              @select-all="handleSelect"
              border
              style="width: 100%">
              <el-table-column
                type="selection"
                :reserve-selection="true"
                width="55">
              </el-table-column>
              <el-table-column
                prop="file_name"
                label="File Name"
                :show-overflow-tooltip="isOverflow"
                sortable>
              </el-table-column>
              <el-table-column
                prop="file_type"
                label="File Type"
                :show-overflow-tooltip="isOverflow"
                width="120"
                sortable>
              </el-table-column>
              <el-table-column
                prop="relate_file"
                label="Relate File"
                :show-overflow-tooltip="isOverflow"
                width="200"
                sortable>
              </el-table-column>
              <el-table-column
                prop="fileSize"
                label="File Size"
                :show-overflow-tooltip="isOverflow"
                width="150"
                sortable>
              </el-table-column>
              <el-table-column
                prop="is_deleted"
                label="Status"
                width="100"
                align="center"
                sortable>
                <template slot-scope="scope">
                  <i style="font-weight: 800" :class="scope.row.upload_status ? 'el-icon-check' : 'el-icon-close colorred'"></i>
                </template>
              </el-table-column>
              <el-table-column
                prop="display_flag"
                label="View"
                width="100"
                sortable>
                <template slot-scope="scope">
                  <el-button :type="scope.row.display_flag ? 'success' : 'info'" size="mini" :disabled="scope.row.display_flag ? '' : 'disabled'" :class="(scope.row.fileType == 'PRIDEXML' || scope.row.fileType == 'MZIDENTML' || scope.row.fileType == 'MZTAB') ? '' : 'disnonecss'">view</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total, prev, pager, next, jumper"
              :total="allNum"
              :page-size="pageSize"
              @current-change="handleChangepage"
              class="pagination mb10">
            </el-pagination>
          </div>
        </el-card>
        <el-card class="box-card mt20" shadow="never">
          <div slot="header" class="clearfix">
            <span><i class="fa fa-cogs fs14" /> Show Log</span>
          </div>
          <div>
            <el-table
              empty-text="No Data"
              :data="logData"
              border
              style="width: 100%">
              <el-table-column
                prop="request_time"
                label="Request Time"
                width="180">
              </el-table-column>
              <el-table-column
                prop="operator"
                label="Operator"
                width="180">
              </el-table-column>
              <el-table-column
                prop="reason"
                label="Reason">
              </el-table-column>
              <el-table-column
                prop="agree_time"
                label="Agree Time">
              </el-table-column>
              <el-table-column
                prop="submit_time"
                label="Submit Time">
              </el-table-column>
              <el-table-column
                prop="operation_type"
                label="Operation Type">
              </el-table-column>
              <el-table-column
                prop="status"
                label="Status">
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>   
  </div>
</template>

<script>
  import { getSubProjectInfoAll, getProjectOptLog, getSearchProjectList, getSubProjectDataList, downloadDataFile, selectStatObjectName } from '@/api'
  export default {
    name: 'project',
    data() {
      const person = {
        Species: '1',
        Diseases: '4',
        Tissues: '2',
        CellTypes: '3',
        Instruments: '9'
      };
      return {
        labelPosition: 'right',
        form: {
          name: '',
          region: '',
          ptitle: '',
          xmlfile: '',
          allfiles: '',
          tissue: '',
          disease: '',
          cell_type: '',
          quantitation: '',
          digest: '',
          ptm: '',
          delivery: false,
          type: [],
          resource: '',
          desc: '',
          rating: 3,
          speciesArr: [],
          speciesCount: 0
        },
        expdesData: [],
        ischecked: false,
        isshowall: false,
        subprojectid: 0,
        ajax_data: {
          filters: [{
            item: "subprojectid",
            equals: ""
          }]
        },
        msData: [],
        expData: [],
        fdrData1: [],
        fdrData: [],
        ajax_data_log: {
          filters: [{
            item: "subprojectid",
            equals: ""
          }]
        },
        logData: [],
        loading: true,
        ajax_data_dfile: {
          search:{
            subproject_id: "",
            sub: ""
          },
          page:{
            startPage: 1,
            pageLength: 5
          },
          order:{
            item: "",
            type: ""
          }
        },
        dfileData: [],
        allNum: 0,
        pageSize: 5,
        orderConvert: {
          ascending: 'asc',
          descending: 'desc'
        },
        searchkey: '',
        speciesUrl: 'https://www.ebi.ac.uk/ols/ontologies/ncbitaxon/terms?iri=http%3A%2F%2Fpurl.obolibrary.org%2Fobo%2F',
        isOverflow: true,
        multipleSelection: [],
        ajax_data_down: {
          'ids': []
        },
        downloadArr: [],
        ajax_data_specat: {
          search: {
            object_name: ''
          }
        }
      }
    },
    mounted() {
      if( this.$route.query.id && this.$route.query.id != '' ){
        this.subprojectid = this.$route.query.id
        this.ajax_data.filters[0].equals = this.$route.query.id
        getSubProjectInfoAll(this.ajax_data).then(res => {
          let redata = res.result[0]
          this.form = redata.basic[0]
          this.msData = redata.ms
          this.expData = redata.expprotocol_detail
          this.fdrData = redata.infoprotocol_detail
          let expdesstr = [{
            sampleval: redata.basic[0].sampleval,
            replicateval: redata.basic[0].replicateval,
            fractionval: redata.basic[0].fractionval,
            samplecontrolval: redata.basic[0].samplecontrolval
          }]
          if(redata.basic[0].sampleval != '' || redata.basic[0].replicateval != '' || redata.basic[0].fractionval != '' || redata.basic[0].samplecontrolval != '') {
            this.expdesData = expdesstr
          }
          let fdrstr = [{
            spectrumval: redata.basic[0].spectrumval,
            peptideval: redata.basic[0].peptideval,
            proteinval: redata.basic[0].proteinval
          }]
          if(redata.basic[0].spectrumval != '' || redata.basic[0].peptideval != '' || redata.basic[0].proteinval != '') {
            this.fdrData1 = fdrstr
          }
          let filesize = this.handleFilesize(redata.basic[0].file_size)
          this.form.file_show = redata.basic[0].file_count + filesize
          let speciesData = redata.species
          speciesData.forEach((val, index) => {
            let object_idstr = this.handleSpeciesUrl(val.object_id)
            val.object_idstr = object_idstr
          })
          console.log(speciesData)
          this.form.speciesArr = speciesData
          this.form.speciesCount = redata.species.length
        })
        this.ajax_data_log.filters[0].equals = this.$route.query.id
        getProjectOptLog(this.ajax_data_log).then(res => {
          this.logData = res.result
        })
        this.loading = true
        this.ajax_data_dfile.search.subproject_id = this.$route.query.id
        this.ajax_data_dfile.search.sub = this.prosekey
        getSubProjectDataList(this.ajax_data_dfile).then(res => {
          this.loading = false
          let newData = res.result
          newData.forEach((val, index) => {
            // let fileCount = val.file_count;
            let filesiz = this.handleFilesize(val.file_size)
            val.fileSize = filesiz
          })
          this.dfileData = newData
          this.allNum = res.count
        })
      }
    },
    created() {
      
    },
    methods: {
      handleProurl(param) {
        let routerData = this.$router.resolve({path: '/project', query: {id: param}})
        window.open(routerData.href, '_blank')
      },
      onSubmit() {},
      handleChangepage (val) {
        this.loading = true
        this.ajax_data_dfile.page.startPage = val
        getSubProjectDataList(this.ajax_data_dfile).then(res => {
          this.loading = false
          this.dfileData = res.result
          this.allNum = res.count
        })
      },
      handleSort (column, prop, order) {
        // console.log(column, prop, order)
        this.loading = true
        this.ajax_data_dfile.order.item = column.prop
        this.ajax_data_dfile.order.type = this.orderConvert[column.order]
        if (column.order !== null && column.prop !== null) {
          getSubProjectDataList(this.ajax_data_dfile).then(res => {
            this.loading = false
            this.dfileData = res.result
            this.allNum = res.count
          })
        } else {
          this.loading = false
        }
      },
      handleSearch() {
        this.loading = true
        this.ajax_data_dfile.search.sub = this.searchkey
        getSubProjectDataList(this.ajax_data_dfile).then(res => {
          this.loading = false
          this.dfileData = res.result
          this.allNum = res.count
        })
      },
      handleFilesize(param) {
        let fileSize = new Number(param);
        if (fileSize == null) {
            fileSize=0;
        } else if (fileSize < 1024) {
            fileSize=fileSize.toFixed(2) + 'K';
        } else if (fileSize >= 1024 && fileSize < 1024 * 1024) {
            fileSize=(fileSize / 1024).toFixed(2) + 'M';
        } else {
            fileSize=(fileSize / 1024 / 1024).toFixed(2) + 'G';
        }
        return fileSize
      },
      handleShowAll(param) {
        this.isshowall = param
      },
      handleSpeciesUrl(param) {
        let urlstr = param.replace(/:/g, '_')
        return urlstr
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      getRowKey (row) {
        return row.file_id
      },
      handleSelect (selection) {
        console.log(selection)
        // let params = '{ids: ['
        // selection.map(item => {
        //   params += '"' + item.file_id + '",'
        // })
        // params += ']}'
        let uniprotIdArr = []
        selection.map(item => {
          uniprotIdArr.push(item.file_id)
        })
        // console.log(params)
        // selection.length === 0 ? this.downVal = '' : this.downVal = params
        this.downloadArr = uniprotIdArr
      },
      handleBatchDownload () {
        // console.log(this.downVal)
        if (this.downloadArr == []) {
          this.$message({
            message: 'Select nothing!',
            type: 'warning'
          })
        } else {
          // document.getElementById('downVal').value = this.downVal
          // document.getElementById('downForm').submit()
          this.ajax_data_down.ids = this.downloadArr
          downloadDataFile(this.ajax_data_down).then(res => {
            let fileData = res.result
            this.downloadFile(fileData,0)
            // fileData.map(item => {
            //   window.open(item.url)
            // })
          })
        }
      },
      downloadFile(list, index) {
        if (index < list.length) {
            console.error('下载第'+index+'个')
          var hiddenIFrameID = 'hiddenDownloader' + index;
          var iframe = document.createElement('iframe');
          iframe.id = hiddenIFrameID;
          iframe.className = 'hiddenIFrameClass';
          iframe.style.display = 'none';
          document.body.appendChild(iframe);
          iframe.src = list[index].url;//直接下载，不会弹出新的页面
            setTimeout(() => {
                index += 1
                this.downloadFile(list, index)
            },1000)
        } else {
          const elements = document.querySelectorAll('.hiddenIFrameClass');  // 替换 className 为要删除元素的 class 名称
          elements.forEach(element => element.remove());
        }
      },
      handleOpenStat(param) {
        console.log(param)
        this.ajax_data_specat.search.object_name = param
        selectStatObjectName(this.ajax_data_specat).then(res => {
          var catVal = res.result[0].object_name
          if(catVal == 'others') {
            const href = this.$router.resolve({path: '/statistics', query: {params: 1, subparams: 'others'}}).href
            window.open(href, '_blank');
          } else {
            const href = this.$router.resolve({path: '/statistics', query: {params: 1, subparams: param}}).href
            window.open(href, '_blank');
          }
        })
        // if( param2 == '' ) {
        //   this.$router.push({path: '/statistics', query: {params: param1}})
        // } else {
        //   this.$router.push({path: '/statistics', query: {params: param1, subparams: param2}})
        // }
      },
      handleOpenCv(param) {
        window.open(this.speciesUrl + param, '_blank');
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .project {
    .formrow {
      line-height: 30px;
    }
    .disnonecss {
      display: none;
    }
  }
</style>
